import React, { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '~/hooks';
import { ROUTER_PATHS } from '~/constants';

interface AuthGuardProps {
  component: JSX.Element;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ component }) => {
  const { isAuthenticated, isCode2FAPending } = useAuth();

  return !isAuthenticated() && !isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.LOGIN} />
  ) : !isAuthenticated() && isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.VERIFY_CODE} />
  ) : (
    <>{component}</>
  );
};

export default AuthGuard;
